import router from 'next/router';

import { LatLngBounds } from '@typings/geo';

import { UpdateUrlWithBoundsMethod } from './map-context.types';

export const parseQueryBounds = (bounds: string) => {
  const queryBoundsArray = bounds.split(',').map(Number.parseFloat);
  return [
    [queryBoundsArray[0], queryBoundsArray[1]],
    [queryBoundsArray[2], queryBoundsArray[3]],
  ] as LatLngBounds;
};

export const boundsToQueryBounds = (bounds: LatLngBounds) =>
  bounds.flat().join(',');

export const updateUrlWithBounds: UpdateUrlWithBoundsMethod = (bounds) => {
  if (typeof window === 'undefined' || !Array.isArray(bounds)) return;

  const url = new URL(window.location.href);
  const queryBounds = url.searchParams.get('bounds');
  const decodedQueryBounds = queryBounds
    ? decodeURIComponent(queryBounds)
    : undefined;

  const newBounds = boundsToQueryBounds(bounds);

  if (decodedQueryBounds !== newBounds) {
    url.searchParams.set('bounds', newBounds);

    router.replace(url.href);
  }
};
